import React from 'react';
import './PastOrder.css';
import { useState,useEffect } from 'react';
import axios from 'axios';
import { var_api,image_api } from '../../constant';
import Swal from 'sweetalert2';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Layout from '../../NewHeader/Layout';
import cimage from '../../../images/burger/b3.png';
import { blue } from '@material-ui/core/colors';
import Pagination from 'react-js-pagination';
import Table from 'react-bootstrap/Table';
import profile from '../../../images/splash/avatar.png';
import Loader from '../../Loader/Loader';

import DefaultProfileImage from '../../../images/profile.png';
// D:\Git\theHerbalAdminFrontend\src\images\ICON\Group2.png
const PastOrder = () => {
  const history = useHistory();
  const [show, setShow]  = useState(false);
  const [tables, setTables] = useState([]);
  const [shops, setShops] = useState([]);
  const [slots, setSlots] = useState([]);
  const [refunds, setRefund] = useState([]);

  const [showRefund, setShowRefund] = useState(false);

  const [selectedShop, setSelectedShop] = useState(null);
  const [ searchQuery,setSearchQuery] = useState('');
  const [selectedItemCode, setSelectedItemCode] = useState(null);
  const [ isEdit,setIsEdit ] = useState(false);
  
  const [ isCreate,setCreate ] = useState(false);

  const [ loading, setLoading ] = useState(false);
  const [ postloading,setPostLoading ] = useState(false);
  const ItemCodeOptions = [

    { value: 'Chef', label: 'Chef' },
    { value: 'Captain', label: 'Captain' },
    { value: 'Waiter', label: 'Waiter' },
    // Add more options as needed
  ];
  const [bookingOrder, setBookingorders] = useState([]);
  const [ itempopup, setItempopup ] = useState(false);
  const [ orderedItems, setorderItems ] = useState([]);
  const [currentOrder, setCurrentOrder] = useState(false);
  const [ setOrdereditempopup, setOrderedItempopup ] = useState(false);
  const [EmployeeD, setEmployeeD] = useState({});
  const [formData, setFormData] = useState({
    e_name: "", 
    e_email: null, 
    e_password: null,
    e_phone: null,
    e_role: "",
    profile: null,
    shops: [],
    user_id: localStorage.getItem("userId")
});
const [updateformData, setUpdateFormData] = useState({
  id:null,
  e_name: "", 
  e_email: null, 
  e_password: null,
  e_phone: null,
  e_role: "",
  profile: null,
  shops: []
});

console.log(formData)
useEffect(() => {
  fetchSlots();
}, []);



const fetchSlots = async () => {
  setLoading(true);
  try {
    const token=localStorage.getItem('Token');
    const shop_id=localStorage.getItem('ShopId');

     const response = await axios.get(`${var_api}slot-master/get/${shop_id}`,{
      headers:{
        Authorization: `${token}`, // Pass user token
      }
     });
     setLoading(false);
     console.log("response",response)
    const user =response.data;
    setSlots(user);
    
  } catch (error) {
    setLoading(false);
    setTables([]);
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('Token'); // Clear the invalid token
      history.push('/')// Redirect to the Sign-In page
    } else {
      console.error("Error fetching data:", error);
    }
  }
};



//change the role
  const handleCodeSelectChange = (selectedItem) => {
    console.log("selectedItem",selectedItem)
    const role = selectedItem.value
    setFormData({ ...formData, e_role: role });
  };

  
//change the shop
const handleShopSelectChange = (selectedItem) => {
  console.log("selectedItem",selectedItem)
  const role = selectedItem.value;
  setSelectedShop(role);
  fetchTables(role);
};
const handleSwitchToggle=()=> {
  // Toggle the switch state
  const newStatus = !this.state.imageStatus;
  this.setState({ imageStatus: newStatus });
  // Update localStorage
  localStorage.setItem('image_status', newStatus ? '1' : '0');
  console.log("imagestatus",localStorage.getItem('image_status'));
};
    


    
      

      const fetchShops = async () => {
        try {
           const shop = localStorage.getItem('userId')
           const response = await axios.get(`${var_api}/api/shop/data/${shop}`);
           console.log("response",response)
          const user =response.data;
          setShops(user);
          setFormData(prevState => ({
            ...prevState,
            shops: user.map(shop => ({ shop_id: shop.id, shop_name: shop.shop_name, is_active: 0 }))
          }));
        } catch (error) {
          console.log(error);
        }
      };

      const shopCodeOptions = [
        { value: 0, label: 'All' },
        ...shops.map(shop => ({
          value: shop.id,
          label: shop.shop_name
        }))
      ];
      
      

     //search the transaction data
     const filteredSuppliers = tables && tables.filter((order) => {
      const searchLower = searchQuery.toLowerCase();
      return (
        (order.e_name && order.e_name.toString().toLowerCase().includes(searchLower)) ||
        (order.e_email && order.e_email.toString().toLowerCase().includes(searchLower))  ||
        (order.e_phone && order.e_phone.toString().toLowerCase().includes(searchLower))  ||
        (order.e_role && order.e_role.toString().toLowerCase().includes(searchLower)) 
      );
    });

//handle image change
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        console.log("files",file);
        setFormData({ ...formData, profile: file });
      };

//handle text field change
const handleInputChange = (event) => {
  const { name, value } = event.target;
  setFormData({
    ...formData,
    [name]: value
  });
};


 // Function to handle checkbox change
 const handleCheckboxChange = (index) => {
  const updatedShops = [...formData.shops];
  const selectedShop = updatedShops[index];
  
  // Toggle is_active property
  updatedShops[index] = {
      ...selectedShop,
      is_active: selectedShop.is_active === 1 ? 0 : 1
  };

  setFormData(prevState => ({
      ...prevState,
      shops: updatedShops
  }));
};


  // Function to capitalize the first letter of a string
  const capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
   };
  

      //post the form data
    const Submit = async (e) => {
      e.preventDefault();
      setPostLoading(true);

      try {

        const camelCaseEName = capitalize(formData.e_name);

        const formDataToSend = new FormData();
        // Append all form fields to the FormData object
        formDataToSend.append('e_name', camelCaseEName);
        formDataToSend.append('e_email', formData.e_email);
        formDataToSend.append('e_password', formData.e_password);
        formDataToSend.append('e_phone', formData.e_phone);
        formDataToSend.append('e_role', formData.e_role);
        formDataToSend.append('profile', formData.profile);
        formDataToSend.append('user_id', formData.user_id);
    
        // Append shop data (if any)
        formData.shops.forEach((shop, index) => {
          formDataToSend.append(`shops[${index}][shop_name]`, shop.shop_name);
          formDataToSend.append(`shops[${index}][shop_id]`, shop.shop_id);
          formDataToSend.append(`shops[${index}][is_active]`, shop.is_active);
        });
        

        const response = await axios.post(`${var_api}/api/employees/post`, formDataToSend, {
            headers: {
                'Content-Type': 'multipart/form-data' // Set content type to multipart/form-data
            }
        });
        const result = response.data;
        console.log("rrrr",result);
        if(result.message === "Employee created successfully"){
          fetchShops();
          setCreate(false);
          fetchTables();
          setPostLoading(false)
          Swal.fire({
            icon:"success",
            text:'Employee Created Successfully',
            confirmButtonColor:"#007500"
          })

          setFormData({...formData,
            e_name: "", 
            e_email: " ", 
            e_password: "",
            e_phone: "",
            e_role: "",
            profile: " "
          })
          

        }
        // Handle successful response (e.g., show a success message to the user)
      } catch (error) {
        // Handle request failure
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      setPostLoading(false)

      console.error('Server responded with error status:', error.response.status);
      if (error.response.data && error.response.data.message) {
        setPostLoading(false)
       
        Swal.fire({
          icon:"error",
          text: error.response.data.message,
          confirmButtonColor:"#007500"
        })
      } else {
        alert('An error occurred. Please try again later.');
      }
    } else if (error.request) {
      // The request was made but no response was received
      console.error('No response received from the server:', error.request);
      setPostLoading(false)
      alert('No response received from the server. Please try again later.');
    } else {
      // Something happened in setting up the request that triggered an Error
      console.error('Error occurred while setting up the request:', error.message);
      setPostLoading(false)
      alert('An error occurred. Please try again later.');
    }
        
      }
    };


  const formatDate = (date) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const [orderType, setOrderType] = useState(0); // Default order type: Credit Order
  const [slotId, setSlotId] = useState(0); // Default slot: Breakfast
  const [orderDate, setOrderDate] = useState(''); // Current date in DD-MM-YYYY format
  const shopId = localStorage.getItem('ShopId');

    // Effect to detect when fromDate becomes empty
    useEffect(() => {
      
      console.log("orderDate", orderDate);
      if (!orderDate || orderDate === 'NaN-NaN-NaN') {
        fetchTables(orderType, slotId); // Fetch without date
      } else {
        fetchTables(orderType, slotId, orderDate); // Fetch with date
      }
    }, [orderDate]);

  const fetchTables = async (selectedOrderType, selectedSlotId, date = null) => {
    const token = localStorage.getItem('Token');
    setLoading(true);

    try {

        // Check if the date is valid or is 'NaN-NaN-NaN'
    const isInvalidDate = date === 'NaN-NaN-NaN' || !date;

      const url = isInvalidDate
            ? `${var_api}booking-orders/past-order-list/${shopId}/${selectedSlotId}/${selectedOrderType}`
            : `${var_api}booking-orders/past-order-list/${shopId}/${selectedSlotId}/${selectedOrderType}/${date}`;
          
          const response = await axios.get(url, {
            headers: {
              Authorization: `${token}` // Ensure correct token format
            }
          });
      setLoading(false);
      const user = response.data.data;
      setTables(user);
    } catch (error) {
      setLoading(false);
      if (error.response && error.response.status === 401) {
        localStorage.removeItem('Token'); // Clear the invalid token
        history.push('/')// Redirect to the Sign-In page
      } else {
        console.error("Error fetching data:", error);
      }
    }
  };

  // Fetch data on mount
  useEffect(() => {
    fetchTables(orderType, slotId);
  }, []);

 // Fetch data when filters change
 const handleFilterChange = (key, value) => {
  if (key === 'orderType') setOrderType(value);
  if (key === 'slotId') setSlotId(value);
  if (key === 'orderDate') setOrderDate(value);

  // Trigger API call with updated filters
  fetchTables(
    key === 'orderType' ? value : orderType,
    key === 'slotId' ? value : slotId,
    key === 'orderDate' ? value : orderDate
  );
};
const [orderItems, setOrderItems] = useState([]);

const handleShow = (items) => {
  setOrderItems(items);
  setShow(true);
};


const handleRefund = (items) => {
  setRefund(items);
  setShowRefund(true);
};
const formatDates = (date) => {
  // Convert DD-MM-YYYY to YYYY-MM-DD
  const [day, month, year] = date.split("-");
  return `${year}-${month}-${day}`;
};
const handleClose = () => setShow(false);
const handleCloseRefund = () => setShowRefund(false);

const [currentPage, setCurrentPage] = useState(1);
const [itemsPerPage] = useState(10); // Number of items per page
const [searchTerm, setSearchTerm] = useState('');

// Filtering tables based on search term
const filteredTables = tables.filter((item) => {
  const orderType = item.order_type === 1 ? "Normal Order" : item.order_type === 2 ? "Credit Order"  : "-";
  const payment = item.payment_status === 1 ? "Paid"  : "Not Paid";
  const orderStatus = item.order_status === 0 ? "New" : item.order_status === 1 ? "Partial"  :item.order_status === 2 ? "Delivered": item.order_status === 4 ? "Cancelled": "Cancelled";
  return (
    item.customer_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    String(item.mobile_no || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.order_no?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.delivery_address?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.delivery_person_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.slot_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    String(item.order_date || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
    String(item.amount).toLowerCase().includes(searchTerm.toLowerCase()) ||
    String(item.booking_dates[0]?.date).toLowerCase().includes(searchTerm.toLowerCase()) ||
    orderType.toLowerCase().includes(searchTerm.toLowerCase()) ||
    payment.toLowerCase().includes(searchTerm.toLowerCase()) ||
    orderStatus.toLowerCase().includes(searchTerm.toLowerCase()) 

  );
});

// Pagination logic
const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;
const currentItems = filteredTables.slice(indexOfFirstItem, indexOfLastItem);
const totalItems = filteredTables.length;

const handleSearchInput = (event) => {
  setSearchTerm(event.target.value);
  setCurrentPage(1); // Reset to the first page when search changes
};

const handlePageChange = (pageNumber) => {
  setCurrentPage(pageNumber);
};
const handleshow =(data, order)=>{
  setBookingorders(data);
  setItempopup(true);
  setCurrentOrder(order)
}
const handleshowItems =(data)=>{
  setorderItems(data);
  setOrderedItempopup(true);
}

 const [showGroupModal, setShowGroupModal] = useState(false);
  const [selectedGroupFoods, setSelectedGroupFoods] = useState([]);

  const handleGroupClick = (groupFoods) => {
    setSelectedGroupFoods(groupFoods);
    setShowGroupModal(true);
  };

//Function for 
    return(
      <>         <Layout>
            <div class="splitpo">

          
          
      <div style={{border:"none", padding:"15px", width:"103%", height:"630px",margin:"auto",borderRadius:"10px",backgroundColor:"white",boxShadow:" rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px, rgba(17, 17, 26, 0.1) 0px 24px 80px", marginTop:"5px"}}>
    
      {/* <Button variant='dark'className='mb-4' onClick={handleCreateEmployee}   style={{fontSize:"17px",float:"right",borderRadius:"10px"}}>Create Category</Button>{' '}
       */}
        <h4 className='ushe'>PAST ORDERS</h4>
        <br/>
      <div>
      <div className="d-flex justify-content-center">
    <div
        className="row align-items-center"
        style={{ maxWidth: "1500px", gap: "15px", width: "100%" }}
    >
        {/* Order Type */}
        <div className="col" style={{ maxWidth: "250px" }}>
            <label htmlFor="selectOrderType" className="form-label" style={{ fontSize: "14px" }}>
                Order Type
            </label>
            <select
  className="form-select form-select-sm"
  id="selectOrderType"
  style={{ fontSize: "15px" }}
  value={orderType}
  onChange={(e) => handleFilterChange('orderType', parseInt(e.target.value))}
>
  <option value="" disabled>
    Select Order Type
  </option>
  <option value={0}>All</option>
  <option value={1}>Normal Order</option>
  <option value={2}>Credit Order</option>
</select>

        </div>

        {/* Slot */}
        <div className="col" style={{ maxWidth: "250px" }}>
            <label htmlFor="selectSlot" className="form-label" style={{ fontSize: "14px" }}>
                Slot
            </label>
           
       <Select
  options={[
    { value: 0, label: "ALL" }, // Add the "ALL" option
    ...slots.map((slot) => ({ value: slot.id, label: slot.slot_name })),
  ]} // Map slots to the required format
  placeholder="Select Slot"
  isSearchable={true}
  className="customSelect m-0"
  value={
    slotId !== null
    ? [
    { value: 0, label: "ALL" },
    ...slots.map((slot) => ({ value: slot.id, label: slot.slot_name })),
        ].find((slot) => slot.value === slotId)
      : null
  } // Find the selected slot as { value, label } object
  onChange={(selectedOption) => handleFilterChange('slotId', selectedOption.value)} // Pass the id to handleFilterChange
/>


        </div>

        {/* From Date */}
        <div className="col" style={{ maxWidth: "250px" }}>
            <label htmlFor="fromDate" className="form-label" style={{ fontSize: "14px" }}>
                 Date
            </label>
            <input
  type="date"
  className="form-control form-control m-0"
  id="fromDate"
  name="fromDate"
  style={{ fontSize: "15px" }}
  value={formatDates(orderDate)} // Ensure orderDate is in DD-MM-YYYY format initially
  onChange={(e) => handleFilterChange("orderDate", formatDate(e.target.value))}
/>

        </div>

        {/* Search */}
        <div className="col" style={{ maxWidth: "300px", marginLeft: 'auto' }}>
            <label htmlFor="search" className="form-label" style={{ fontSize: "14px" }}>
                Search
            </label>
            <input
                type="search"
                className="form-control form-control m-0"
                id="search"
                placeholder="Search"
                onChange={handleSearchInput}
                style={{ fontSize: "15px" }}
            />
        </div>
    </div>
</div>


      <div className="table-container" style={{ height:"500px", overflowX: 'auto', overflowY: 'scroll', marginTop:"10px" }}>
      <table class="table table-hover small-first-col" style={{border:"none",borderColor:"grey",width:"95%",margin:"auto"}}>
  <thead>
    <tr style={{fontWeight:"bolder"}}>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">S.No</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Customer name</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Mobile</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Order Id</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Ordered Time</th>

      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Order Address</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Order Type</th>
      {/* <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Slot Type</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Slot Name</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Slot Time</th> */}

      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Delivery Person</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Delivery Time</th>

      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Delivery Date</th>

      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Amount</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Payment Status</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Refund Status</th>

      {/* <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Refund Amount</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Refund Paymend Method</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Refund Transaction ID</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Reject Remarks</th> */}

      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Status</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Action</th>

    </tr>
  </thead>
  {loading ? (
        <Loader/>
  ) : 
  <tbody className="body-half-screen" style={{ fontSize: "14.5px" }}>
  {currentItems && currentItems.length > 0 ? (
    currentItems.map((order, index) => (
      <tr style={{ padding: "4px",borderBottom:"0.5px solid black" }} key={index} >
        <th scope="row" style={{ textTransform: "capitalize", textAlign: "left" }}>
          {indexOfFirstItem + index + 1}
        </th>

        <td style={{ textTransform: "capitalize", textAlign: "left" }}>
          {order.customer_name || "-"}
        </td>
        <td style={{ textTransform: "capitalize", textAlign: "left" }}>
          {order.mobile_no || "-"}
        </td>
        <td style={{ textTransform: "capitalize", textAlign: "left" , color:"blue" }}>
          {order.order_no || "-"}
        </td>
        <td style={{ textTransform: "capitalize", textAlign: "left" }}>
          {order.order_time || "-"}
        </td>
        <td style={{ textTransform: "capitalize", textAlign: "left" }}>
          {order.delivery_address || "-"}
        </td>
        <td style={{
            textTransform: "capitalize",
            textAlign: "left",
            color: order.order_type === 1 ? "purple" : "orange",
            fontWeight: "bold"
          }}>
          {order.order_type === 1 ? "Normal Order" : order.order_type === 2 ? "Credit Order" : "-"}
        </td>
      
        {/* <td style={{ textTransform: "capitalize", textAlign: "left", display: "flex", alignItems: "center", gap: "10px" }}>
  <div>
    {order.delivery_person_name || "-"}
  </div>
  <img
    src={order.delivery_person_profile ? `${image_api}/${order.delivery_person_profile}` : DefaultProfileImage}
    alt="profile"
    width="65px"
    height="60px"
    style={{ borderRadius: "8px", objectFit: "cover" }}
  />
</td> */}

<td
  style={{
    textAlign: "center",
    display: "flex",
    borderTop: "none",
    borderBottom: "none",
    alignItems:'center',

    gap: "20px",
    alignContent: "center",
    // marginTop: "11px",
    height: "100px",
  }}
>
  {order.delivery_person_name ? (
    <>
      {order.delivery_person_profile && (
        <img
        src={profile}
          alt="profile"
          style={{
            width: "30px",
            height: "30px",
            objectFit: "cover",
            borderRadius: "50%",
          }}
        />
      )}
      {order.delivery_person_name}
    </>
  ) : (
    "-"
  )}
</td>
        <td style={{ textTransform: "capitalize", textAlign: "left" }}>
          {order.delivered_time || "-"}
        </td>
        <td style={{ textTransform: "capitalize", textAlign: "left" }}>
        {order.booking_dates[0]?.date || '-'}
        </td>
        
        <td style={{ textTransform: "capitalize", textAlign: "left" }}>
          ${order.amount || "-"}
        </td>
        <td style={{
            textAlign: "left",
            color: order.payment_status === 0 ? "red" : "green",
            fontWeight: "bold"
          }}>
            {order.payment_status === 0 ? "Not Paid" : "Paid"}
           
          </td>
        <td style={{ textTransform: "capitalize", textAlign: "left" }}>
  {order.is_refund === 1 ? (
    <button  onClick={() => handleRefund(order)} className="btn btn-success btn-sm" style={{ fontSize: "12px" }}>
      Refunded
    </button>
  ) : (
    <button className="btn btn-secondary btn-sm" style={{ fontSize: "12px" }} disabled>
      No Refunds
    </button>
  )}
</td>

        {/* <td style={{ textTransform: "capitalize", textAlign: "left" }}>
          {order.refund_amount || "-"}
        </td>
        <td style={{ textTransform: "capitalize", textAlign: "left" }}>
          {order.refund_payment_method || "-"}
        </td>
        <td style={{ textTransform: "capitalize", textAlign: "left" }}>
          {order.refund_transaction_id || "-"}
        </td>
        <td style={{ textTransform: "capitalize", textAlign: "left" }}>
          {order.reject_remarks || "-"}
        </td> */}
          <td style={{
          textAlign: "left",
          color: order.order_status === 0 ? "blue" :
          order.order_status === 1 ? "orange" :
          order.order_status === 2 ? "green" :
          order.order_status === 3 ? "red" : "gray",
          fontWeight: "bold",
        }}>
          {order.order_status === 0 ? "New" :
           order.order_status === 1 ? "Partial" :
           order.order_status === 2 ? "Delivered" :
           order.order_status === 4 ? "Cancelled" : "Cancelled"}
        </td>
        <td>
        <button
              className="btn btn-primary"
              onClick={() => handleshow(order.booking_dates, order)}
              style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
            >
              <i style={{ color: "white", fontSize: "13px" }} className="bi bi-eye-fill"></i>
            </button>
        </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="20" style={{ textAlign: "center", color: "red", fontWeight: "bold" }}>
        No Data Available
      </td>
    </tr>
  )}
</tbody>

}
</table>

<Pagination
        activePage={currentPage}
        itemsCountPerPage={itemsPerPage}
        totalItemsCount={totalItems}
        pageRangeDisplayed={5}
        onChange={handlePageChange}
        itemClass="page-item"
        linkClass="page-link"
        innerClass="pagination justify-content-end"
        activeClass="active-pagination"
      />
      </div>
      

</div>
        </div>
      
      </div>

      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Order Items</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {orderItems.length > 0 ? (
            <table className="table">
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Food Image</th>

                  <th>Food Name</th>
                  <th>Item Code</th>

                  <th>Quantity</th>
                  <th>Unit Price</th>
                  <th>Remarks</th>
                </tr>
              </thead>
              <tbody>
                {orderItems.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td style={{textTransform:"capitalize",textAlign:"left"}}> <img
            src={`${image_api}/${item.food_image}`}
            alt="profile"
            style={{ width: '75px', height: '65px', objectFit: 'cover' }}
          /></td>
                    <td>{item.food_name}</td>
                    <td>{item.item_code}</td>

                    <td>{item.quantity}</td>
                    <td>{item.unit_price}</td>
                    <td>{item.remark}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p>No order items available.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showRefund} onHide={handleCloseRefund} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>REFUND DETAILS</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <table className="table">
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Refund Date</th>

                  <th>Refund Amount</th>
                  <th>Payment Method</th>

                  <th>Transaction ID</th>
                  <th>Refund Remarks</th>
                  {/* <th>Remarks</th> */}
                </tr>
              </thead>
              <tbody>
                  <tr >
                    <td>{ 1}</td>
                
                    <td>{refunds.refund_date}</td>
                    <td>{"$"+refunds.refund_amount}</td>

                    <td>{refunds.refund_payment_method}</td>
                    <td>{refunds.refund_transaction_id}</td>
                    <td>{refunds.refund_remarks}</td>
                  </tr>
              </tbody>
            </table>
         
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleCloseRefund}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
  show={itempopup}
  onHide={() => setItempopup(false)}
  backdrop="static"
  keyboard={false}
  size="lg"
>
  <Modal.Header closeButton>
    <Modal.Title>Delivery Dates</Modal.Title>
  </Modal.Header>
  <Modal.Body>
  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", margin:"15px 15px"}}>
  <h6>
    Order Id: <span style={{fontSize:"20px", color: "blue"}}>{currentOrder.order_no}</span>
  </h6>
  <h6 >
    Customer Name: <span style={{fontSize:"18px", color: "blue"}}>{currentOrder.customer_name}</span>
  </h6>
  <h6>
    Customer Mobile: <span style={{fontSize:"18px", color: "blue"}}>{currentOrder.mobile_no}</span>
  </h6>
</div>
    {/* Bill-Like List Design */}
    <Table hover style={{ marginBottom: "20px" }}>
      <thead>
        <tr style={{ backgroundColor: "#f8f9fa", fontWeight: "bold", color: "green" }}>
          <th>S.No</th>
          <th>Delivery Date</th>
          <th>Slot Name</th>
          <th>From Time</th>
          <th>To Time</th>
          <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Delivery Person</th>

          <th> Status</th>

          <th>View List</th>

        </tr>
      </thead>
      <tbody>
  {bookingOrder.length > 0 ? (
    bookingOrder.map((dateItem, dateIndex) =>
      dateItem.slots.length > 0 ? (
        dateItem.slots.map((slot, slotIndex) => (
          <tr key={`${dateIndex}-${slotIndex}`} style={{borderBottom:"0.5px solid black"}}>
            <td>{slotIndex + 1}</td>
            <td>{dateItem.date}</td>
            <td>{slot.slot_name}</td>
            <td>{slot.from_time}</td>
            <td>{slot.to_time}</td>
            <td
  style={{
    textAlign: "bottom",
    display: "flex",
    borderTop: "none",
    borderBottom: "none",
    alignItems:'center',
    gap: "20px",
justifyContent:'center',
    // marginTop: "11px",
    height: "100px",
  }}
>
  {slot.slot_delivery_person_name ? (
    <>
      {slot.slot_delivery_person_profile && (
        <img
          src={profile}
          alt="profile"
          style={{
            width: "30px",
            height: "30px",
            objectFit: "cover",
            borderRadius: "50%",
          }}
        />
      )}
      {slot.slot_delivery_person_name}
    </>
  ) : (
    "-"
  )}
</td>
            <td style={{
          textAlign: "left",
          color: slot.slot_status === 0 ? "blue" :
          slot.slot_status === 1 ? "rgb(50, 184, 23)" :
          slot.slot_status === 2 ? "rgb(184, 184, 2)" :
          slot.slot_status === 3 ? "orange" : 
          slot.slot_status === 4 ? "gray" : 
          slot.slot_status === 5 ? "green" : 
          "red",
          fontWeight: "bold",
        }}>
           {slot.slot_status === 0 ? "New" :
           slot.slot_status === 1 ? "Order Accepted" :
           slot.slot_status === 2 ? "Inprogress" :
           slot.slot_status === 3 ? "Packed" :
           slot.slot_status === 4 ? "Picked up" : 
           slot.slot_status === 5 ? "Delivered" :
           "Cancelled"}
        </td>
            <td>
              <button className="btn btn-primary" onClick={() => handleshowItems(slot.order_items)}>
                <i style={{ color: "white", fontSize: "20px" }} className="bi bi-eye-fill"></i>
              </button>
            </td>
          </tr>
        ))
      ) : (
        <tr key={dateIndex}>
          <td colSpan="6" style={{ textAlign: "center", color: "red", fontWeight: "bold" }}>
            No data available
          </td>
        </tr>
      )
    )
  ) : (
    <tr>
      <td colSpan="6" style={{ textAlign: "center", color: "red", fontWeight: "bold" }}>
        No data available
      </td>
    </tr>
  )}
</tbody>

    </Table>
    {/* <button
      className="btn btn-danger"
      onClick={() => setItempopup(false)}
      style={{ borderRadius: "15px", float: "right", marginTop: "-1px" }}
    >
      Cancel
    </button> */}
  </Modal.Body>
</Modal>
<Modal
  show={setOrdereditempopup}
  onHide={() => setOrderedItempopup(false)}
  backdrop="dynamic"
  keyboard={false}
  size="xl"
>
  <Modal.Header closeButton>
    <Modal.Title>Items</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {/* Bill-Like List Design */}
    <Table hover style={{ marginBottom: "20px" }}>
      <thead>
        <tr style={{ backgroundColor: "#f8f9fa", fontWeight: "bold", color: "green" }}>
          <th>S.No</th>
          <th>Image</th>

          <th>Food Name</th>
          <th>Item Code</th>
          <th>Quantity</th>
          <th>Unit Price</th>
          <th>Variant Name</th>
          <th>Sub Variant</th>
          <th>Is Organic</th>
          <th>Remarks</th>
          <th>Additional Notes</th>
          <th>group foods</th>
        </tr>
      </thead>
      <tbody>
      {orderedItems.length > 0 ? (

      orderedItems.map((item, index) => (
          <tr key={index} style={{ borderBottom: "1px solid #ddd" }}>
            <td>{index + 1}</td>
            <img
  src={`${image_api}/${item.food_image}`}
  alt="item_image"
  width="50px"
  height="50px"
/>


            <td>{item.food_name}</td>
            <td>{item.item_code}</td>
            <td>{item.quantity}</td>
            <td>{item.unit_price}</td>
            <td>{item.variant_name}</td>
            <td>{item.sub_variant_name}</td>
            <td>{item.is_organic == 0 ? "Regular" : item.is_organic == 1 ? "Organic" : "N/A"}</td>
            <td>{item.remark}</td>
            <td>
  <div className="notes-cell" title={item.additional_notes}>
    {item.additional_notes}
  </div>
  </td>
  <td>
                  {item.group_items && item.group_items.length > 0 ? (
                    <span
                      style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}
                      onClick={() => handleGroupClick(item.group_items)}
                    >
                      {item.group_items.length} item(s)
                    </span>
                  ) : (
                    <span style={{ color: "gray" }}>No group foods</span>
                  )}
                </td>

          </tr>
          
        )))
        : (
          <tr>
            <td colSpan="8" style={{ textAlign: "center", color: "red", fontWeight: "bold" }}>
              No data available
            </td>
          </tr>
        )}
      </tbody>
    </Table>
    {/* <button
      className="btn btn-danger"
      onClick={() => setItempopup(false)}
      style={{ borderRadius: "15px", float: "right", marginTop: "-1px" }}
    >
      Cancel
    </button> */}
  </Modal.Body>
</Modal>

 <Modal show={showGroupModal} onHide={() => setShowGroupModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Group Foods</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedGroupFoods.length > 0 ? (
            <ul>
              {selectedGroupFoods.map((gf, idx) => (
                <li key={idx}>
                  <strong>{gf.group_name}</strong> - {gf.sub_group_name}
                </li>
              ))}
            </ul>
          ) : (
            <p>No group foods available.</p>
          )}
        </Modal.Body>
      </Modal>

            {/* </div> */}
       </Layout></>

        
    )
}

export default PastOrder;